:host {
  display: inline-block;

    /** @prop --foreground-color: Defines the foreground color. */
    --foreground-color: var(--dnn-color-foreground, #000);

    /** @prop --background-color: Defines the background color. */
    --background-color: var(--dnn-color-background, #fff);
  
    /** @prop --focus-color: Defines the color when the component is focused. */
    --focus-color: var(--dnn-color-primary, #3792ED);
  
    /** @prop --danger-color: Defines the danger color used for invalid data. */
    --danger-color: var(--dnn-color-danger, #900);
  
    /** @prop --control-radius: Defines the radius for the control corners. */
    --control-radius: var(--dnn-controls-radius, 3px);
}

dnn-fieldset{
  width: 100%;
}

textarea{
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--foreground-color);
  width: calc(100% - 1em);
  height: calc(100% - 1em);
  line-height: 1.5em;
  resize: none;
}

dnn-fieldset{
  --fieldset-foreground-color: var(--foreground-color);
  --fieldset-background-color: var(--background-color);
  --fieldset-focus-color: var(--focus-color);
  --fieldset-danger-color: var(--danger-color);
  --fieldset-control-radius: var(--control-radius);
}

svg{
  &.error{
    fill: red;
    width: 1em;
    height: 1em;
    transform: scale(1.5);
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }
}